module.exports = __webpack_public_path__ + "img/hr-branch-particle-06.7c4c390c.png";